Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = '2.3.0-9';
//# sourceMappingURL=SearchkitVersion.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/core/SearchkitVersion.js
// module id = 348
// module chunks = 0